
const STATUS_EMBARQUE = {
   'EN_CREACION': 0,
   'REGISTRADO': 1,
   'GUIAS_ASIGNADAS': 2,
   'SALIDA_MARCADA': 3,
   'LLEGADA_SUCURSAL': 4,
   'FIN_CIRCUITO': 5,
}

const STATUS_GUIAS = {
   'CANCELADA': 0,
   'DOCUMENTADA': 1,
   'EMBARCADA': 2,
   'OCURRE': 3,
   'ASIGNADA': 5,
   'ENTREGADA': 6,
   'LLEGO_SUCURSAL': 7,
   'RUTA_EAD': 8,
   'LISTA_OCURRE': 9,
   'EN_TRANSITO': 10,
   'PRE_DOCUMENTADA': 20,
   'RE_DOCUMENTADA': 21,
   'EMBARQUE_RETRASADO': 22,
   'DESEMBARCADA': 23,
}

export { STATUS_EMBARQUE, STATUS_GUIAS };